import base_house from '../../VUE/src/pages/oni-mansion-game/assets/base_house.png';
import base_house_small from '../../VUE/src/pages/oni-mansion-game/assets/base_house_small.png';
import base_house_grayscale from '../../VUE/src/pages/oni-mansion-game/assets/base_house_grayscale.png';
import house_sky from '../../VUE/src/pages/oni-mansion-game/assets/house_sky.png';
import house_sky_small from '../../VUE/src/pages/oni-mansion-game/assets/house_sky_small.png';
import stars from '../../VUE/src/pages/oni-mansion-game/assets/stars.png';
import stars_small from '../../VUE/src/pages/oni-mansion-game/assets/stars_small.png';
import candle_counter from '../../VUE/src/pages/oni-mansion-game/assets/main_screen/candle_counter.png';
import empty_image from '../../VUE/src/pages/oni-mansion-game/assets/empty_image.png';
import twitter_button from '../../VUE/src/pages/oni-mansion-game/assets/twitter_button.png';
import play_opensea from '../../VUE/src/pages/oni-mansion-game/assets/play_opensea.png';
import pause_opensea from '../../VUE/src/pages/oni-mansion-game/assets/pause_opensea.png';

export const HOUSE_PREVIEW_GAME_ASSETS = [
  {
    name: 'empty_image',
    image: empty_image,
  },
  {
    name: 'base_house',
    image: base_house,
  },
  {
    name: 'base_house_small',
    image: base_house_small,
  },
  {
    name: 'base_house_grayscale',
    image: base_house_grayscale,
  },
  {
    name: 'house_sky',
    image: house_sky,
  },
  {
    name: 'house_sky_small',
    image: house_sky_small,
  },
  {
    name: 'stars',
    image: stars,
  },
  {
    name: 'stars_small',
    image: stars_small,
  },
  {
    name: 'candle_counter',
    image: candle_counter,
  },
  {
    name: 'twitter_button',
    image: twitter_button,
  },
  {
    name: 'play_opensea',
    image: play_opensea,
  },
  {
    name: 'pause_opensea',
    image: pause_opensea,
  },
];
